<div class="relative inline-block">
    <div *ngIf="mode === 'determinate'">
        <mat-spinner
            class="determinate"
            [diameter]="40"
            [strokeWidth]="4"
            [mode]="mode"
            [value]="progress"
            color="accent"
        >
        </mat-spinner>
        <span class="spinner-label">{{ progress }}%</span>
    </div>

    <div *ngIf="mode === 'indeterminate'">
        <mat-spinner [diameter]="40" [strokeWidth]="4" [mode]="mode" color="accent"></mat-spinner>
    </div>
</div>
